import { SearchSort } from '@aipb/gulliver/castor/model';
import { CatalogRecHeader, CustomRecordItem } from '@aipb/gulliver/catalog/model';
import { ScoreComponent } from '@aipb/gulliver/catalog/ui';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { HeaderLabelComponent } from '../header-label/header-label.component';
import { HeaderLicenseComponent } from '../header-license/header-license.component';
import { HeaderTagsComponent } from '../header-tags/header-tags.component';
import { SafeHtmlPipe } from "@aipb/shared/ui/pipes";
import { CatalogEnvService } from "@aipb/gulliver/catalog/env";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'cat-header-content',
  standalone: true,
  imports: [CommonModule, HeaderLabelComponent, HeaderLicenseComponent, HeaderTagsComponent, ScoreComponent, MatButtonModule, MatIconModule, SafeHtmlPipe],
  templateUrl: './header-content.component.html',
  styleUrls: ['./header-content.component.scss']
})
export class HeaderContentComponent {
  @Input() item: CustomRecordItem;
  @Input() header: CatalogRecHeader;
  @Input() sort: SearchSort[] = [];
  @Input() sortString: string;
  @Input() hideSortInHeader: boolean;
  @Input() compact = false;

  @Output() action = new EventEmitter<CustomRecordItem>();

  private catalogEnv = inject(CatalogEnvService);

  get headerFormat() {
    return this.catalogEnv.env.headerFormat;
  }

  getEncodedHtml() {
    if(!this.item.GulliverRecHeaderHTML) {
      return '<div>Chyba v datech</div>'
    }
    return this.item.GulliverRecHeaderHTML.replaceAll('%GULLIVER_URL%', this.catalogEnv.env.headerGulliverUrl).replaceAll('%FORMATTER_API_URL%', this.catalogEnv.env.fetchDetailApiUrl);
  }
}
